const $inject = [];
const lbaTimeZoneSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaTimeZoneSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaTimeZoneSelect.html')
  }
};

lbaTimeZoneSelect.$inject = $inject;

export default lbaTimeZoneSelect;



// WEBPACK FOOTER //
// ./src/components/lbaTimeZoneSelect/lbaTimeZoneSelectDir.js